import Scene = Phaser.Scene;
import {Point} from "@/model/point";
import {Keys} from "@/constants/key";

export default class AnimationUtils {

    public static getFrameSize(key: string): Point {
        if (key === 'dark_golem' || key === 'ice_golem' || key === 'rock_golem') {
            return new Point(115, 125);
        } else if (key === 'seth-ent') {
            return new Point(116, 144);
        } else if (key === '6-frogman-yellow' || key === '6-frogman-blue' || key === '6-frogman-pink'
            || key === '9-goblin-arc' || key === '9-goblin-sham' || key === '9-goblin-warr') {
            return new Point(58, 72);
        } else if (key === Keys.LOADING_ANIM) {
            return new Point(80, 80);
        } else if (key === Keys.ANIM_BIRD_FLIGHT) {
            return new Point(80, 80);
        } else if (key === Keys.ANIM_BLUE_BIRD_FLIGHT) {
            return new Point(80, 80);
        }
        throw new Error();
    }

    public static createAnimation(scene: Scene, key: string, frameRateRatio: number = 1.0): Phaser.Animations.Animation | boolean | undefined {
        switch (key) {
            case 'dark_golem':
                return scene.anims.create({
                    key: key,
                    frames: scene.anims.generateFrameNumbers(key, {frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
                            13, 14, 15, 16, 17, 18, 19]}),
                    frameRate: 12,
                    repeat: -1
                });
            case 'ice_golem':
            case 'rock_golem':
            case 'seth-ent':
            case Keys.ANIM_BIRD_FLIGHT:
            case Keys.ANIM_BLUE_BIRD_FLIGHT:
                return scene.anims.create({
                    key: key,
                    frames: scene.anims.generateFrameNumbers(key, {frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
                            13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29]}),
                    frameRate: 18,
                    repeat: -1
                });

            case Keys.LOADING_ANIM:
                return scene.anims.create({
                    key: key,
                    frames: scene.anims.generateFrameNumbers(key, {frames: [0, 1, 2, 3, 4, 5, 6, 7]}),
                    frameRate: 12,
                    repeat: -1
                });

            case Keys.ANIM_KNIGHT_IDLE_M:
            case Keys.ANIM_KNIGHT_IDLE_W:
                return scene.anims.create({
                    key: key,
                    frames: scene.anims.generateFrameNumbers(key, {
                        frames: [
                            0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                            10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                            20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
                            30, 31, 32, 33, 34, 35, 36, 37, 38, 39]
                    }),
                    frameRate: 16,
                    repeat: -1
                });
            case Keys.ANIM_KNIGHT_WALK_M:
            case Keys.ANIM_KNIGHT_WALK_W:
                return scene.anims.create({
                    key: key,
                    frames: scene.anims.generateFrameNumbers(key, {
                        frames: [
                            0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                            10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                            20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
                            30, 31, 32, 33, 34, 35, 36, 37, 38, 39]
                    }),
                    frameRate: 36 * frameRateRatio,
                    repeat: -1
                });

            case 'man_back_idle':
            case 'man_front_idle':
            case 'woman_back_idle':
            case 'woman_front_idle':
            case 'acolyte_front_idle':
                return scene.anims.create({
                    key: key,
                    frames: scene.anims.generateFrameNumbers(key, {frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                            10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                            20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
                            30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
                            40, 41, 42, 43, 44, 45, 46, 47, 48, 49]}),
                    frameRate: 30,
                    repeat: -1
                });

            case 'man_back_walk':
            case 'man_front_walk':
            case 'woman_back_walk':
            case 'woman_front_walk':
            case 'acolyte_front_walk':
                return scene.anims.create({
                    key: key,
                    frames: scene.anims.generateFrameNumbers(key, {frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                            10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                            20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
                            30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
                            40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
                            50, 51, 52, 53, 54, 55, 56, 57, 58, 59]}),
                    frameRate: 36 * frameRateRatio,
                    repeat: -1
                });
        }
        return undefined;
    }
}
